export default class ClubFile {
    constructor() {
        this.id = null;
        this.title = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubFile = new ClubFile();
        clubFile.id = data.id;
        clubFile.title = data.title;

        return clubFile;
    }

    serialize() {
        return {
            id: this.id,
            title: this.title,
        };
    }
}
